import { motion } from "motion/react";
import type { ReactNode } from "react";
import { CanvasToolbarShell } from "./CanvasToolbarShell";

interface CanvasFloatingToolbarFrameProps {
  children: ReactNode;
  className?: string;
  onMouseDown?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onPointerDown?: (e: React.PointerEvent<HTMLDivElement>) => void;
}

/**
 * Zoom-invariant floating toolbar chrome — motion wrapper + horizontal shell.
 */
export function CanvasFloatingToolbarFrame({
  children,
  onMouseDown,
  onPointerDown,
  className,
}: CanvasFloatingToolbarFrameProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 8 }}
      transition={{ duration: 0.15, ease: "easeOut" }}
      className={className ?? "mx-auto w-fit"}
      onMouseDown={onMouseDown}
      onPointerDown={onPointerDown}
    >
      <CanvasToolbarShell orientation="horizontal" className="max-w-none">
        {children}
      </CanvasToolbarShell>
    </motion.div>
  );
}
